import { useState } from "react";
import { ReportTemplatesAPI } from "../../../api/ReportTemplates";
import { I, getToken, getErrorMessage } from "../ReportsPanel";
import { legacyTemplatePayload } from "./legacyTemplates";

const CATEGORY_LABELS = {
  ventas: "Ventas",
  inventario: "Inventario",
  operacion: "Operación",
};

// Catalogo de reportes legacy ("Plantillas SmartPay"), agrupado por categoria. Al elegir uno
// se pide solo nombre + descripcion (no hay bloques/metricas que configurar - la plantilla
// conserva internamente su reporte legacy) y se crea la instancia en el backend. El catalogo
// se carga una sola vez en ReportsPanel y se pasa por props (tambien lo necesita LegacyPreviewView).
export default function SmartpayCatalogView({ catalog, loading, error, businessCode, onBack, onCreated }) {
  const [selected, setSelected] = useState(null);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");

  const selectEntry = (entry) => {
    setSelected(entry);
    setName(entry.name);
    setDescription(entry.description || "");
    setSaveError("");
  };

  const create = async () => {
    if (!selected || !name.trim()) return;
    setSaving(true);
    setSaveError("");
    try {
      const payload = legacyTemplatePayload({ name: name.trim(), description, legacy_report_code: selected.code }, businessCode);
      const response = await ReportTemplatesAPI.createTemplate(payload, getToken());
      const created = response?.data?.data || response?.data;
      onCreated(created, selected);
    } catch (err) {
      setSaveError(getErrorMessage(err, "No se pudo crear la plantilla"));
    } finally {
      setSaving(false);
    }
  };

  const grouped = catalog.reduce((acc, entry) => {
    const key = entry.category || "otros";
    (acc[key] = acc[key] || []).push(entry);
    return acc;
  }, {});

  return (
    <>
      <div className="rb-top-bar">
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <button className="rb-back-btn" onClick={() => (selected ? setSelected(null) : onBack())}><I.ArrowLeft /></button>
          <div className="rb-top-title">Plantillas SmartPay</div>
        </div>
      </div>

      {loading && <div className="rb-empty"><div className="rb-empty__title">Cargando catálogo...</div></div>}
      {error && <div className="rb-empty"><div className="rb-empty__title">No se pudo cargar el catálogo</div><div className="rb-empty__desc">{error}</div></div>}

      {!loading && !error && !selected && Object.entries(grouped).map(([category, entries]) => (
        <div key={category} className="rb-section">
          <div className="rb-section-title">{CATEGORY_LABELS[category] || category}</div>
          <div className="rb-template-grid">
            {entries.map((entry) => (
              <button key={entry.code} className="rb-tpl-card rb-tpl-card--select" onClick={() => selectEntry(entry)}>
                <div className="rb-tpl-card__head">
                  <div className="rb-tpl-card__info">
                    <span className="rb-tpl-card__emoji"><I.Sparkle /></span>
                    <div><div className="rb-tpl-card__name">{entry.name}</div></div>
                  </div>
                </div>
                <div className="rb-tpl-card__body">
                  <div className="rb-tpl-card__desc">{entry.description}</div>
                  <div className="rb-tpl-card__blocks">
                    {entry.capabilities?.excel && <span className="rb-block-pill">Excel</span>}
                    {entry.capabilities?.pdf && <span className="rb-block-pill">PDF</span>}
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      ))}

      {selected && (
        <div className="rb-section" data-tour="builder-info">
          <div className="rb-section-title">Nueva plantilla desde "{selected.name}"</div>
          {saveError && <div style={{ fontSize: 12, color: "#C53030", marginBottom: 10 }}>{saveError}</div>}
          <div className="rb-fg"><label className="rb-label">Nombre</label><input className="rb-input" value={name} onChange={e => setName(e.target.value)} /></div>
          <div className="rb-fg"><label className="rb-label">Descripción</label><textarea className="rb-input rb-textarea" value={description} onChange={e => setDescription(e.target.value)} /></div>
          <button className="rb-btn-primary" disabled={saving || !name.trim()} onClick={create}>
            <I.Save /> {saving ? "Creando..." : "Crear plantilla"}
          </button>
        </div>
      )}
    </>
  );
}
